import * as UTILS_SERVICE from '@/services/utils'

const UTILS = { ...UTILS_SERVICE }

export default UTILS
